import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "home",
  class: "flex flex-column text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-5 mb-2" }, "Home", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "It happears you're not logged in.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Please login or register to continue.", -1)
const _hoisted_6 = { class: "cta-section w-min flex mx-auto gap-4" }
const _hoisted_7 = { key: 1 }

import { useUserStore } from '../stores/UserStore';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const userStore = useUserStore();
const router = useRouter();

function onGoToLogin(){
  router.push('/login');
}

function onGoToRegister(){
  router.push('/register');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (!_unref(userStore).loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Button), {
              label: "Login",
              onClick: onGoToLogin
            }),
            _createVNode(_unref(Button), {
              label: "Register",
              onClick: onGoToRegister
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(Button), {
            label: "Log Out",
            onClick: _unref(userStore).logOutUser
          }, null, 8, ["onClick"])
        ]))
  ]))
}
}

})